export class ScanCard {

  private _originalData: string;
  private _cardID: string;
  private _sectorData: string;
  private _scanTime: Date;

  static createFromAny(object: any): ScanCard {
    if (!object) {
      return null;
    }

    const scanCard = ScanCard.createFromCardCode(object.cardID);
    scanCard._scanTime = new Date(object.scanTime);

    return scanCard;
  }

  static createFromCardCode(cardCode: string): ScanCard {
    const scanCard = new ScanCard();
    scanCard._originalData = cardCode;
    if (cardCode) {
      const items = cardCode.split(';');
      if (items.length > 0) {
        scanCard._cardID = items[0];
      }
      if (items.length > 1) {
        scanCard._sectorData = items[1];
      }
    }
    return scanCard;
  }

  static hexToString(hex: string): string {
    if (!hex) {
      return '';
    }
    let result = '';
    for (let i = 0; (i < hex.length && hex.substr(i, 2) !== '00'); i += 2) {
      result += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return result;
  }

  static removeZeros(data: string): string {
    if (!data) {
      return data;
    }
    return '' + parseInt(data, 10);
  }

  get originalData(): string {
    return this._originalData;
  }

  get cardID(): string {
    return this._cardID;
  }

  get personalNumber(): string {
    return ScanCard.removeZeros(ScanCard.hexToString(this.sectorData));
  }

  get sectorData(): string {
    return this._sectorData;
  }

  get scanTime(): Date {
    return this._scanTime;
  }
}
